let GWP = {};
const GWPSchema = document.querySelector('[data-GWP-schema]');
if(GWPSchema){
  GWP = JSON.parse(GWPSchema.innerHTML);
}
class customGWPJS {
    constructor() {
        this.ajaxCart = document.querySelector('ajax-cart');
    }
  
    cartGWP(location = 'cartDrawer'){
        const currentUrl = new URL(window.location.href)
        this.ajaxCart = document.querySelector('ajax-cart');
        this.location = !currentUrl.pathname.includes('/cart') ? 'cartDrawer': 'cartPage';
        
        const cart = window.globalVariables.cart;
        let  GWPGift = false;
        let [thresholdValue, existedFreeProduct, existedFreeProductLine] = [null, null, null];
        let [finalThresholdAmount, orginalThresholdAmount, updateQty] = [null, null, false];
        let [eligibleThreshold, eligibleFreeProduct, eligibleFreeProductJSON, cartTotal] = [null, null, null, 0];
        cart.items.forEach((product, index)=>{
            if(product.properties && product.properties['product_type'] == 'GWP Gift'){
                GWPGift = true;
                existedFreeProductLine = index + 1;
                existedFreeProduct = product.variant_id;
                if(product.quantity > 1){
                    updateQty = true;
                }
                if(product.variant_id == GWP.threshold_1['gwp_pro']){
                    thresholdValue = 1;
                }else if(product.variant_id == GWP.threshold_2['gwp_pro']){
                    thresholdValue = 2;
                }else if(product.variant_id == GWP.threshold_3['gwp_pro']){
                    thresholdValue = 3;
                }
            }else{
                if(product.product_type != 'Gift Card'){
                    cartTotal = cartTotal + product.final_line_price;
                }
            }
        });
        if(GWP.enable == 'true'){
            if(GWP.threshold_3['enable'] && cartTotal >= GWP.threshold_3['amount']){
                eligibleThreshold = 3;
            }else if(GWP.threshold_2['enable'] && cartTotal >= GWP.threshold_2['amount']){
                eligibleThreshold = 2;
            }else if(GWP.threshold_1['enable'] && cartTotal >= GWP.threshold_1['amount']){
                eligibleThreshold = 1;
            }
            if(eligibleThreshold != null){
                let selectedThreshold = GWP[`threshold_${eligibleThreshold}`];
                [eligibleFreeProduct,eligibleFreeProductJSON] = [selectedThreshold.gwp_pro, selectedThreshold.gwp_pro_JSON];
                [finalThresholdAmount,orginalThresholdAmount] = [selectedThreshold.amount, selectedThreshold.original_amount];
            }
        }
        let removeProduct = JSON.stringify({
            line: existedFreeProductLine,
            quantity: 0
        });
        if((GWP == undefined || eligibleThreshold == null) && GWPGift) {
            this.updateGWPvariant(removeProduct, ()=> {
                if(this.ajaxCart) this.ajaxCart.getCartData();
            });
        }else if((thresholdValue && thresholdValue != eligibleThreshold && eligibleFreeProduct != null) 
        || (existedFreeProduct != null && existedFreeProduct != eligibleFreeProduct)){
            this.updateGWPvariant(removeProduct, ()=> {
                if(GWP.auto_add){
                    this.addFreeProToCart(orginalThresholdAmount, eligibleFreeProductJSON);
                }else{
                    if(this.ajaxCart) this.ajaxCart.getCartData();
                    this.showFreeProduct(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON);
                }
            });
        }
        else if(updateQty){
            let updateProduct = JSON.stringify({
                line: existedFreeProductLine,
                quantity: 1
            });
            this.updateGWPvariant(updateProduct, ()=>{
                if(this.ajaxCart) this.ajaxCart.getCartData();
            });
        }else if(eligibleThreshold != null && eligibleFreeProduct != null && !GWPGift){
            if(GWP.auto_add){
                this.addFreeProToCart(orginalThresholdAmount, eligibleFreeProductJSON);
            }else{
                this.showFreeProduct(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON);
            }
        }
    }
    updateGWPvariant(body, callback){
        let fetchCart = fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }});
        fetchCart.then(response => {
          return response.json();
        }).then(response => {
          if (typeof callback == "function") return callback(response);
        }).catch((e) => {
          console.error(e);
          return callback(e);
        })
    }
    addFreeProToCart(orginalThresholdAmount, eligibleFreeProductJSON){
        if(eligibleFreeProductJSON == null){
            return;
        }
        const body = JSON.stringify({
            id: eligibleFreeProductJSON.variants[0].id,
            quantity: 1,
            properties: {
              product_type: 'GWP Gift',
              spend_over: orginalThresholdAmount
            }
        });
        let fetchCart = fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body }});
        fetchCart.then(response => {
            return response.json();
        }).then(_response => {
            if(this.ajaxCart) this.ajaxCart.getCartData();
        }).catch((e) => {
            console.error(e);
        });
    }
    
    cartDrawerProductHTML(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON) {
        return`
            <div class="row px-3 align-items-center cart-item">
                <div class="row">
                    <div class="col-12 gwp-heading">
                        <div class="general-text mb-3 text-center">
                            You Are Eligible For A Free Gift With Your Purchase Over ${Shopify.formatMoney(finalThresholdAmount, window.globalVariables.money_format)}
                        </div>
                    </div>
                </div>

                <div class="row gwp-body">
                    <div class="col-12 mb-3 mb-md-0 cart-product-img d-flex align-items-center">
                        <div class="row no-gutter d-flex align-items-center gwp-product">
                            <div class="cart-img col-4">
                                <a href="/products/${eligibleFreeProductJSON.handle}">
                                    <img class="gift_img" src="${eligibleFreeProductJSON.featured_image}" loading="lazy" width="75" height="95" />
                                </a>
                            </div>

                            <div class="cart-item-text col-8">
                                <a href="/products/${eligibleFreeProductJSON.handle}" class="card-title fw-medium">${eligibleFreeProductJSON.title}</a>
                                <div class="cart-price">
                                    <span class="orgi_price ajaxcart__price">$0 | <del>${Shopify.formatMoney(eligibleFreeProductJSON.price, window.globalVariables.money_format)}</del></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3 mb-md-0">
                        <div class="quantity-box mt-3 mb-3">
                            <button type="button" name="add" class="btn btn-dark btn-sm add-to-cart" data-orginalThresholdAmount="${orginalThresholdAmount}" data-addID="${eligibleFreeProductJSON.variants[0].id}" data-addFreeItem><span>Add to cart</span></button>
                        </div>
                    </div>
                </div>
            </div>`;
    }

    cartRowProductHTML(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON) {
        return `
            <div class="row">
                <div class="col-12 gwp-heading">
                    <div class="general-text mb-3 text-center">
                        You Are Eligible For A Free Gift With Your Purchase Over ${Shopify.formatMoney(finalThresholdAmount, window.globalVariables.money_format)}
                    </div>
                </div>
            </div>

            <div class="row align-items-center cart-item mb-3">
                <div class="col-12 mb-3 mb-md-0 col-md-5 cart-product-img">
                    <div class="d-flex align-items-center">
                        <div class="cart-img ">
                            <a href="/products/${eligibleFreeProductJSON.handle}">
                                <img class="gift_img img-fluid item-img" src="${eligibleFreeProductJSON.featured_image}" loading="lazy" width="75" height="95" />
                            </a>
                        </div>
                        <div class="cart-item-text col-8">
                            <a href="/products/${eligibleFreeProductJSON.handle}" class="card-title fw-bold">${eligibleFreeProductJSON.title}</a>
                        </div>
                    </div>
                </div>
                <div class="col-4 col-md-2 text-md-center">
                    <div class="cart-price">
                        <span class="orgi_price ajaxcart__price">$0 | <del>${Shopify.formatMoney(eligibleFreeProductJSON.price, window.globalVariables.money_format)}</del></span>
                    </div>
                </div>
                <div class="col-3 col-md-3 quantity-box">
                </div>
                <div class="col-5 col-md-2 text-end cart-total-price">
                     <div class="quantity-box mt-3 mb-3">
                        <button type="button" name="add" class="btn btn-dark btn-sm add-to-cart" data-orginalThresholdAmount="${orginalThresholdAmount}" data-addID="${eligibleFreeProductJSON.variants[0].id}" data-addFreeItem><span>Add to cart</span></button>
                    </div>
                </div>
            </div>
        `
    } 

    showFreeProduct(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON){
        if(eligibleFreeProductJSON == null){
            return;
        }        

        const freeProductHTML = this.location === 'cartDrawer' ? 
            this.cartDrawerProductHTML(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON) : 
            this.cartRowProductHTML(orginalThresholdAmount, finalThresholdAmount, eligibleFreeProductJSON);

        const freeGiftParent = document.querySelector('[data-freeGift]');
        if(freeGiftParent){
            freeGiftParent.innerHTML = freeProductHTML;
            freeGiftParent.style.display = 'block';
        }
        const addItemBtns = document.querySelector('[data-addFreeItem]');
        if(addItemBtns == null) return;
        addItemBtns.addEventListener('click', (event)=>{
            event.preventDefault();
            const currentTarget = event.currentTarget;
            const body = JSON.stringify({
                id: currentTarget.getAttribute('data-addid'),
                quantity: 1,
                properties: {
                    product_type: 'GWP Gift',
                    spend_over: currentTarget.getAttribute('data-orginalThresholdAmount')
                }
            });
            let fetchCart = fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body }});
            fetchCart.then(response => {
                return response.json();
            }).then(_response => {
                if(this.ajaxCart) this.ajaxCart.getCartData();
            }).catch((e) => {
                console.error(e);
            });
        });
    }
}
typeof customGWPJS !== 'undefined' && new customGWPJS();